

<!-- Main Container -->
<div class="login-container">

  <!-- Left Side - Form -->
  <div class="login-form-side">

    <!-- Go Back Link (TOP RIGHT - EXACT LOGIN STYLE) -->
    <a href="javascript:void(0)" class="go-back-link" (click)="goBack()">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
      Go Back
    </a>

    <div class="login-form-wrapper">

      <!-- Page Title (EXACT LOGIN STYLE) -->
      <!-- <h1 class="page-title">Login</h1> -->

      <!-- Logo (EXACT LOGIN STYLE) -->
      <div class="login-logo">
        <div class="logo-icon">RTT</div>
        <div class="logo-text">
          <div class="logo-company">RealTimeTrac</div>
          <div class="logo-tagline">Delivery Management System</div>
        </div>
      </div>

      <!-- Tagline (EXACT LOGIN STYLE) -->
      <div class="login-header">
        <div class="page-tagline">YOUR CUSTOMERS' TIME VALUED</div>
      </div>

      <!-- Phone Number Form -->
      <form *ngIf="step === 'phone'" [formGroup]="phoneForm" (ngSubmit)="onSendOtp()" class="login-form">

        <div style="display: flex; gap: 16px;">
          <div class="form-group" *ngIf="showCountryCode">
            <label class="form-label">
              Country code <span class="required-indicator">*</span>
            </label>
            <div class="input-row">
              <!-- Country Code (NARROW - 110px) -->
              <select formControlName="countryCode" class="form-input country-select">
                <option *ngFor="let country of countryCodes" [value]="country.dial_code">
                  {{ country.code }} {{ country.dial_code }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group" style="width: 100%;">
            <label class="form-label">
              Phone No / Email <span class="required-indicator">*</span>
            </label>
            <div>
              <!-- Phone Number (WIDE) -->
              <div class="phone-input-wrapper">
                <input [type]="inputType === 'phone' ? 'tel' : 'email'" formControlName="phoneNumber" class="form-input"
                  [class.error]="hasPhoneError" placeholder="Enter Phone No / Email"
                  [maxlength]="inputType === 'phone' ? 10 : 254"
                  [attr.inputmode]="inputType === 'phone' ? 'numeric' : 'email'" (input)="onPhoneNumberChange()" />

              </div>
            </div>

            <!-- Error Message -->
            <div class="error-message" [class.show]="hasPhoneError">
              <svg fill="currentColor" viewBox="0 0 20 20" width="16" height="16">
                <path fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd" />
              </svg>
              {{ phoneErrorMessage }}
            </div>
          </div>
        </div>
        <!-- Send Button (WITH ARROW) -->
        <button type="submit" class="login-button" [disabled]="loading">
          <i *ngIf="loading" class="fa fa-spinner fa-spin"></i>
          <span *ngIf="!loading">Send OTP</span>
          <span *ngIf="loading">Sending...</span>
          <svg *ngIf="!loading" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="20" height="20">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </button>

        <!-- NO TERMS TEXT (REMOVED AS REQUESTED) -->
      </form>

      <!-- OTP Verification Section -->
      <div *ngIf="step === 'otp'" class="otp-section">

        <!-- OTP Header -->
        <div class="otp-header">
          <h2 class="otp-title">Verify OTP</h2>
          <p class="otp-subtitle">
            We've sent a 6-digit code to<br />
            <strong>{{ phoneNumber }}</strong>
          </p>
        </div>

        <!-- OTP Input Boxes -->
        <div class="form-group">
          <label class="form-label">
            Enter OTP <span class="required-indicator">*</span>
          </label>
          <div class="otp-inputs" (paste)="onOtpPaste($event)">
            <input *ngFor="let digit of otp; let i = index" [id]="'otp' + (i + 1)" type="text" maxlength="1"
              class="otp-input" [value]="otp[i]" (input)="onOtpInput($event, i)" (keydown)="onOtpKeydown($event, i)"
              pattern="[0-9]" inputmode="numeric" />
          </div>
          <div class="otp-error" *ngIf="isOtpInvalid">
            OTP is required
          </div>
        </div>

        <!-- OTP Actions -->
        <!-- <div class="otp-actions">
          <button type="button" class="btn-link" (click)="onResendOtp()" [disabled]="loading">
            Resend OTP
          </button>
          <span class="separator">|</span>
          <button type="button" class="btn-link" (click)="goBackToPhone()">
            Change Number
          </button>
        </div> -->
        <div class="form-options">
          <div class="remember-me">
            <a class="forgot-password" (click)="onResendOtp()" [class.disabled]="isResendOtpDisabled"
              [style.cursor]="isResendOtpDisabled ? 'not-allowed' : 'pointer'"
              [style.opacity]="isResendOtpDisabled ? '0.5' : '1'">
              <span *ngIf="!isResendOtpDisabled">Resend OTP</span>
              <span *ngIf="isResendOtpDisabled">Resend OTP in {{ getResendOtpTimerDisplay() }}s</span>
            </a>
          </div>
          <a *ngIf="inputType === 'email'" class="forgot-password" (click)="goBackToPhone()">Change Email</a>
          <a *ngIf="inputType != 'email'" class="forgot-password" (click)="goBackToPhone()">Change Number</a>
        </div>
        <!-- Verify Button (WITH ARROW) -->
        <button type="button" class="login-button" (click)="verifyOtp()" [disabled]="loading">
          <i *ngIf="loading" class="fa fa-spinner fa-spin"></i>
          <span *ngIf="!loading">Verify</span>
          <span *ngIf="loading">Verifying...</span>
          <svg *ngIf="!loading" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="20" height="20">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </button>
      </div>

    </div>
  </div>

  <!-- Right Side - Slider (EXACT LOGIN STYLE) -->
  <div class="illustration-side">
    <div class="slider-container">

      <!-- Tagline -->
      <h2 class="slider-tagline">
        Schedule. <span class="highlight-green">TRAC</span>. Deliver on <span class="highlight-yellow">Time</span>
      </h2>

      <!-- Slider Wrapper (EXACT LOGIN STYLE) -->
      <div class="slider-wrapper">

        <!-- Previous Arrow -->
        <button class="slider-arrow prev" (click)="prevSlide(); resetSlider()">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <!-- Next Arrow -->
        <button class="slider-arrow next" (click)="nextSlide(); resetSlider()">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>

        <!-- Slides (EXACT LOGIN STYLE) -->
        <div *ngFor="let slide of slides; let i = index" class="slide" [class.active]="currentSlide === i">
          <div class="slide-image">
            <img [src]="slide.image" [alt]="slide.title">
          </div>
          <div class="slide-content">
            <h3 class="slide-title">{{ slide.title }}</h3>
            <p class="slide-description">{{ slide.description }}</p>
          </div>
        </div>
      </div>

      <!-- Progress Bar -->
      <div class="slider-progress">
        <div class="slider-progress-bar" [style.width.%]="((currentSlide + 1) / slides.length) * 100"></div>
      </div>

      <!-- Navigation Dots -->
      <div class="slider-nav">
        <div *ngFor="let slide of slides; let i = index" class="slider-dot" [class.active]="currentSlide === i"
          (click)="goToSlide(i)"></div>
      </div>
    </div>
  </div>

</div>